import * as React from 'react';
import { GetAttendanceForEmployeeMobileRequest, VovClient } from '../../../ApiOld/ApiServerVov';
import { useApi } from '../../../ApiOld/Api/useApi';
import { Box, CircularProgress, Grid, Stack, Tab, Typography } from '@mui/material';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';

import { useTranslation } from 'react-i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MobileAttendanceWorkTab from './MobileAttendanceWorkTab';
import MobileAttendanceNonworkTab from './MobileAttendanceNonworkTab';
import YearMonthStepper from '../Components/YearMonthStepper';
import { AttendanceResponseDTO, EmployeeMobileVovClient, MobileApplicationsVovClient } from '../../../ApiOld/Api/ApiServerVov';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { useSnackbar } from 'notistack';
import LoadingIndicator from '../Shared/LoadingIndicator';

export interface IMobileAttendanceTabsProps {
}

export default function MobileAttendanceTabs(props: IMobileAttendanceTabsProps) {
    const { authorizedMobileEmployeeApi } = useMobileApi(EmployeeMobileVovClient);
    const [month, setMonth] = React.useState<number>(new Date().getMonth() + 1);
    const [year, setYear] = React.useState<number>(new Date().getFullYear());
    const [attendanceData, setAttendanceData] = React.useState<AttendanceResponseDTO[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    React.useEffect(() => {
        try {
            setLoading(true);
            authorizedMobileEmployeeApi.getAttendanceForEmployeeMobile(new GetAttendanceForEmployeeMobileRequest({ year: year, month: month })).then((res) => {
                console.log(res);
                setAttendanceData(res?.attendance?.data ?? []);
                setLoading(false);
                //setAttendanceData(getValues(res.attendance!.dates));
            }).catch((err) => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar(t('errorLoadingData'), { variant: 'error', autoHideDuration: 3000 });
            });


        } catch (error) {
            console.log(error);
        }
    }, [year, month]);

    /* const getValues = (data: { [key: string]: AttendanceResponseDTO } | undefined) => {
        if (!data || !data.dates) {
            return []; // Return an empty array if `dates` is undefined
        }
        return Object.values(data.dates); // Get all the values from the `dates` object
    }; */

    const [value, setValue] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 56px)' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                        sx={{
                            backgroundColor: '#FFC600',
                            color: 'black',
                            '& .Mui-selected': {
                                color: 'black !important',
                                fontWeight: 'bold',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'black',
                            },
                        }}
                        onChange={handleChange}
                        aria-label="mobile-attendance-tabs"
                    >
                        <Tab label={<Typography sx={{ fontWeight: 'bold' }}>{t('diary.works')}</Typography>} value="1" sx={{ flex: 1 }} />
                        <Tab label={<Typography sx={{ fontWeight: 'bold' }}>{t('freetime')}</Typography>} value="2" sx={{ flex: 1 }} />
                    </TabList>
                </Box>
                <Box sx={{ flex: 1, overflowY: 'auto' }}>
                    <TabPanel value="1">
                        {!loading && <MobileAttendanceWorkTab data={attendanceData} />}
                        {loading && <LoadingIndicator />}
                    </TabPanel>
                    <TabPanel value="2">
                        {!loading && <MobileAttendanceNonworkTab data={attendanceData} />}
                        {loading && <LoadingIndicator />}
                    </TabPanel>
                </Box>
            </TabContext>
            <YearMonthStepper month={month} year={year} setMonth={setMonth} setYear={setYear} />
        </Box>);
}
